<template name="comp-tab">
  <div class="comp-tabs" :style="tabsStyle">
    <div class="tab" :style="tabStyle"
      v-for="(item, i) in options" :key="i" 
      :class="{active: activeNum===i}" 
      @click="handleClickTab(i, item)">{{ item.label || item.i18nValue }}</div>
  </div>
</template>

<script>
  export default {
    name: 'compTabs',
    props: {
      options: {
        type: Array,
        default() {
          return []
        },
      },
      tabsStyle: {
        type: String,
        default: ''
      },
      tabStyle: {
        type: String,
        default: ''
      },
      defaultIndex: {
        type: Number,
        default: 0,
      }
    },

    data() {
      return {
        activeNum: 0, // 当前激活项
      }
    },
    computed: {

    },
    created() {
      if (this.options.length) {
        const index = this.defaultIndex;
        this.handleClickTab(index, this.options[index])
      }
    },
    methods: {
      handleClickTab(i, item) {
        this.activeNum = i;
        this.$emit('change', i, item)
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
